import "./KnowlaLogo.scss";

/** Knowla wordmark shown next to the main menu when the board is opened
 * directly (not embedded in web.knowla.eu). */
export const KnowlaLogo = () => (
  <div className="knowla-logo">
    <img
      src="/Knowla_logo_navy_babyblue_RGB.png"
      alt="Knowla"
      draggable={false}
    />
  </div>
);
